import { cva } from 'class-variance-authority'

export const avatarStyles = cva(['shrink-0'], {
  variants: {
    size: {
      xxs: 'w-5 h-5',
      xs: 'h-6 w-6',
      sm: 'h-8 w-8',
      md: 'h-10 w-10',
      lg: 'h-12 w-12',
      xl: 'h-16 w-16',
      '2xl': 'h-24 w-24',
      '3xl': 'h-32 w-32',
    },
    rounded: {
      none: 'rounded-none',
      sm: 'rounded-avatar',
      md: 'rounded-avatar',
      base: 'rounded-base',
      avatar: 'rounded-avatar',
    },
  },
  defaultVariants: {
    rounded: 'avatar',
  },
})

export const avatarIconStyles = cva(
  [
    'absolute bottom-1 end-1',
    'bg-surface rounded-avatar text-xs text-content-subdued',
    'transform translate-x-1/2 translate-y-1/2',
  ],
  {
    variants: {
      size: {
        xxs: 'h-3 w-3',
        xs: 'h-3 w-3',
        sm: 'h-3 w-3',
        md: 'h-4 w-4',
        lg: 'h-4 w-4',
        xl: 'h-4 w-4 ',
        '2xl': 'h-5 w-5 ',
        '3xl': 'h-6 w-6 ',
      },
    },
  },
)

export const avatarSizeClasses = {
  xs: 'h-6 w-6',
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
  xl: 'h-16 w-16',
  '2xl': 'h-24 w-24',
  '3xl': 'h-32 w-32',
}

export const avatarSizeInPixel = {
  xxs: 20,
  xs: 24,
  sm: 32,
  md: 40,
  lg: 48,
  xl: 64,
  '2xl': 96,
  '3xl': 128,
}
